import http from '../utils/http-common'

const getAll = (param) => {
  return http.get('/item-categories', { params: param })
}

const ItemCategoriesDataService = {
  getAll,
}
export default ItemCategoriesDataService
